// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"7d8fbe65","39":"47036adb","59":"d6fe070a","213":"e59d1968","447":"1c52b738","459":"a54c1681","510":"a6f1e1f3","670":"12affed6","686":"e9992af1","719":"845da213","840":"dbb52598","895":"cb3b2a15","975":"01186624"}[chunkId] + ".chunk.js";
};